module.exports = __webpack_public_path__ + "static/media/7-mobile.6c82a2c7.jpg";